/* Scoped product-panel cleanup. Preserve DOM slots used by existing tab routing. */
(() => {
  const script = document.currentScript;
  const handle = script && script.dataset.mlPanelHandle;
  const allowed = ["the-motion-cool-truffle-16-inch-wig-archive-piece-copy","espresso-16-inch-wavy-topper-archive-piece","archive-topper-cappuccino-16","sample-piece-warm-brown-curls","daily-wig-essentials","the-motion-archive-piece-cool-truffle","the-motion-archive-piece-cappuccino","the-motion-archive-piece-vienna-blonde","silk-sleep-set","no-slip-grip-cap","velvet-no-slip-wig-band","wig-grid-knot-erase","silicone-wig-grip-band","hair-hanger","pure-shampoo-conditioner-bundle","elodie-luxury-lace-front-bob-human-hair-wig","monroe-products-monroe-human-hair-wig","gift-card"];
  if (!allowed.includes(handle)) return;
  const apply = () => {
    const main = script.closest('main');
    const drawer = main && main.querySelector('#Product-Information-Drawer');
    if (!drawer || drawer.dataset.mlPanelCleaned) return;
    const tabs = Array.from(drawer.querySelectorAll('.side-panel-content--tabs > button'));
    const panels = Array.from(drawer.querySelectorAll('.side-panel-content--tab-panel'));
    const launchers = Array.from(main.querySelectorAll('side-panel-links:not(.ml-product-use-link) > button'));
    if (tabs.length !== 3 || panels.length !== 3 || launchers.length !== 3) return;
    const empty = panel => !panel.textContent.trim() && !panel.querySelector('img,video,iframe,svg,table,input');
    const hairPieces = ['espresso-16-inch-wavy-topper-archive-piece','archive-topper-cappuccino-16','sample-piece-warm-brown-curls'];
    if (hairPieces.includes(handle) && empty(panels[2])) {
      const links = [
        ['/pages/wig-topper-care-guide','Read the wig and topper care guide'],
        ['/pages/build-your-wig-topper-care-routine','Build a wig or topper care routine'],
        ['/pages/contact','Ask Moxi Loxi about this piece']
      ];
      panels[2].replaceChildren(...links.map(([href, text]) => {
        const p = document.createElement('p');
        const a = document.createElement('a');
        a.href = href; a.textContent = text; p.append(a); return p;
      }));
    }
    const hidden = panels.map((panel, i) => empty(panel) && (i === 0 || (handle === 'gift-card' && i === 2)));
    hidden.forEach((hide, i) => {
      if (!hide) return;
      [tabs[i], panels[i], launchers[i]].forEach(el => {
        el.hidden = true;
        el.style.setProperty('display', 'none', 'important');
      });
    });
    if (tabs.some((tab, i) => hidden[i] && tab.classList.contains('tab-active'))) {
      const first = hidden.findIndex(hide => !hide);
      tabs.forEach((tab, i) => tab.classList.toggle('tab-active', i === first));
      panels.forEach((panel, i) => panel.classList.toggle('tab-active', i === first));
    }
    drawer.dataset.mlPanelCleaned = 'true';
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, {once: true});
  else apply();
})();